<template>
  <div
    v-if="GlobalFunctions.isExtendedRecommendedJobType(activeJob) && !!activeJob?.matchScore"
    class="i-why-matched"
  >
    <template v-if="showRecommendation">
      <div class="text">{{ activeJob.recommendation }}</div>
    </template>
    <iMatchGraph />
    <template v-if="showMatchedReasons">
      <iKeywordDetailsSummary
        :data="activeJob.matchReasons.items"
        :summary="activeJob.matchReasons.summary"
        :show-keys="false"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

import { GlobalFunctions } from "@/helpers/globalFunctions"

import iMatchGraph from "@/components/report/careers/MatchGraph.vue"
import iKeywordDetailsSummary from "@/components/report/KeywordDetailsSummary.vue"

// STORES
const reportStore = useReportStore()

// COMPUTED
const activeJob = computed(() => reportStore.getActiveJob)
const showRecommendation = computed(
  () =>
    GlobalFunctions.isExtendedRecommendedJobType(activeJob.value) &&
    (!activeJob.value?.matchReasons.summary || !hasMatchReasonsItems(activeJob.value?.matchReasons.items)) &&
    !!activeJob.value?.recommendation
)
const showMatchedReasons = computed(
  () =>
    GlobalFunctions.isExtendedRecommendedJobType(activeJob.value) &&
    !!activeJob.value?.matchReasons.summary &&
    hasMatchReasonsItems(activeJob.value?.matchReasons.items)
)

// FUNCTIONS
const hasMatchReasonsItems = (items: { [title: string]: string }) => {
  return !!items && typeof items === "object" && Object.keys(items).length > 0
}
</script>

<style lang="scss" scoped>
.i-why-matched {
  margin-bottom: 45px;

  .text {
    margin: 15px 0 25px;
    color: $comet600;

    @include text-sm;

    font-weight: 500;

    @media screen and (min-width: $breakpoint-sm) {
      @include text-md;
    }
  }
}
</style>
